import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Mar 02 2020
 * @author Tsv
 */
import moment from 'moment';
import * as React from 'react';
import { getDateFormat, translate } from '../../../../..';
import { DatePickerValidated } from '../../../../inputs/DatePicker';
import CellEditor from './CellEditor';
import { OptionalDesc, PropDesc, ValidationError } from '@logio/common-be-fe';
/**
 * Date editor for the AgGrid column endDate
 * @extends CellEditor
 */

var ReleaseSelloutEndDateEditor =
/*#__PURE__*/
function (_CellEditor) {
  _inherits(ReleaseSelloutEndDateEditor, _CellEditor);

  function ReleaseSelloutEndDateEditor(props) {
    var _this;

    _classCallCheck(this, ReleaseSelloutEndDateEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReleaseSelloutEndDateEditor).call(this, props));
    _this.parser = ReleaseSelloutEndDateEditor.getParser(_this.colDef.schema); // updateValue(data) {
    //   this.props.context.store.setValid(!!this.validationError);
    //   this.setState({value: data, validationError: this.validationError});
    // }

    /**
     * Handles changes in the input element of the date picker
     */

    _this.onChange = function (date) {
      _this.updateValue(date);
    };
    /** Disables non valid dates */
    // get dayPickerProps() {
    //   const finalPrice: FinalProductPrice = this.props.data.SelloutReleaseItemPrices_finalPrice;
    //   if (finalPrice) {
    //     return {disabledDays: [finalPrice.validFrom.toDate(), {before: finalPrice.validFrom.toDate()}]};
    //   }
    // }


    _this.isPopup = function () {
      return true;
    };

    _this.render = function () {
      return React.createElement("div", {
        ref: _this.wrapper
      }, React.createElement(DatePickerValidated, {
        value: _this.state.value,
        onChange: _this.onChange,
        validationError: _this.validationError
      }));
    };

    return _this;
  }

  _createClass(ReleaseSelloutEndDateEditor, [{
    key: "validationCondition",
    value: function validationCondition(finalPrice) {
      var validationError = null;

      if (finalPrice) {
        var validFrom = finalPrice.validFrom.clone().add(24, 'hours');

        if (!this.state.value.isAfter(moment()) || !this.state.value.isAfter(validFrom)) {
          validationError = new ValidationError(translate('err-less-start-date', validFrom.format(getDateFormat())));
        }
      }

      return validationError;
    }
  }, {
    key: "validationError",

    /** Validates input */
    get: function get() {
      var _this2 = this;

      var validationError = null;

      if (this.state.value) {
        var isBulk = this.props.node.rowIndex === 0 && this.props.node.rowPinned === 'top';
        var finalPrice;

        if (isBulk) {
          this.props.api.forEachNode(function (node) {
            finalPrice = node.data.SelloutReleaseItemPrices_finalPrice;
            validationError = _this2.validationCondition(finalPrice);
          });
        } else {
          finalPrice = this.props.data.SelloutReleaseItemPrices_finalPrice;

          if (this.state.value) {
            validationError = this.validationCondition(finalPrice);
          }
        }
      }

      return validationError;
    }
  }], [{
    key: "getParser",
    value: function getParser(schema) {
      if (schema instanceof PropDesc) {
        return schema.parser;
      }

      if (schema instanceof OptionalDesc) {
        return ReleaseSelloutEndDateEditor.getParser(schema.base);
      }

      throw new Error('Can not determine parser');
    }
  }]);

  return ReleaseSelloutEndDateEditor;
}(CellEditor);

export { ReleaseSelloutEndDateEditor as default };